module.exports = __webpack_public_path__ + "static/media/customer_survey_amber.3556f3ea.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/customer_survey_amber.svg
// module id = 1088
// module chunks = 2